import suiteService from 'qreventos-suite/services';
import { CommonService } from 'qreventos-suite/src/services/common.services';

export class SeguridadService extends CommonService {

  private LOCAL_STORAGE_NAME = "UDATA";
  private LOCAL_STORAGE_EXP = "UDATA_EXP";
  private TTL_MS = 1000 * 60 * 60 * 3; // 3 horas

  async login(evento: number, mail: string, password: string): Promise<string> {
    const hash: string = await suiteService.auth(evento, mail, password, 2) as string; // 2 - Mail
    if (hash != null) {
      this.setItemLocalStorage(hash);
    }
    return hash;
  }

  async logout() {
    try {
      localStorage.removeItem(this.LOCAL_STORAGE_NAME);
      localStorage.removeItem(this.LOCAL_STORAGE_EXP);
    } catch (error) {
      throw super.manageError(error);
    }
  }

  getLocalHash(): string | undefined {
    const hash = localStorage.getItem(this.LOCAL_STORAGE_NAME);
    const exp = localStorage.getItem(this.LOCAL_STORAGE_EXP);

    if (!hash || !exp) {
      return undefined;
    }

    const expNumber = Number(exp);

    // Limpiar si está vencido
    if (Date.now() > expNumber) {
      localStorage.removeItem(this.LOCAL_STORAGE_NAME);
      localStorage.removeItem(this.LOCAL_STORAGE_EXP);
      return undefined;
    }

    // Renovar
    localStorage.setItem(this.LOCAL_STORAGE_EXP, (Date.now() + this.TTL_MS).toString());
    return hash;
  }

  private setItemLocalStorage(hash: string) {
    localStorage.setItem(this.LOCAL_STORAGE_NAME, hash);
    localStorage.setItem(this.LOCAL_STORAGE_EXP, (Date.now() + this.TTL_MS).toString());
  }
}

export default new SeguridadService();